import React, {PureComponent} from 'react';
import $ from "jquery";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

class LineChart extends PureComponent {

    constructor(props) {
        super(props);
        const helper = this;

        let data = [{
            name: this.props.dataName,
            data: this.props.data,
            color: (this.props.color ? this.props.color : '#ff0012'),
            zones: (this.props.thresholdCode60 !== undefined && this.props.thresholdCode60 > 0) ? [{value: this.props.thresholdCode60, color: "#70b304"}, {color: "#ff0012"}] : [],
        }];

        this.setHoverData = this.setHoverData.bind(this);

        this.state = {
            // To avoid unnecessary update keep all options in the state.
            chartOptions: {
                chart: {
                    type: (this.props.thresholdCode60 !== undefined && this.props.thresholdCode60 > 0) ? "area" : "line",
                    // Edit chart spacing
                    spacingBottom: 8,
                    spacingTop: 8,
                    spacingLeft: 10,
                    spacingRight: 10,

                    // Explicitly tell the width and height of a chart
                    width: null,
                    height: 235,
                    style: {
                        fontFamily: 'Iceland',
                        fontColor: "#FFFFFF"
                    },
                },
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true
                },
                labels: {
                    align: 'right',
                    x: -10,
                    y: 0
                },
                title: {
                    text: '',
                    floating: true,
                    align: 'right',
                    x: -30,
                    y: 30
                },
                yAxis: {
                    title: "",
                    max: this.props.maxYAxis,
                    min: this.props.minYAxis,
                    tickInterval: this.props.tick,
                },
                xAxis: {
                    crosshair: {enabled: true},
                },
                series: data,
                plotOptions: {
                    series: {
                        visible: true,
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        },
                        point: {
                            events: {
                                mouseOver: this.setHoverData
                            }
                        },
                        threshold: (this.props.thresholdCode60 !== undefined && this.props.thresholdCode60 > 0) ? this.props.thresholdCode60 : 0,
                    }
                },
                tooltip: {
                    hideDelay: 0,
                    useHTML: true,
                    formatter: function () {
                        let finalSTR = "";
                        $.each(this.points, function () {
                            if (helper.props.additionalData) {
                                finalSTR += ('<b style="font-size: 15px;">' + this.series.name + '</b>: <strong style="font-size: 25px">' + this.y + ' ' + helper.props.unit + '</strong><br/>' +
                                    ' <b style="font-size: 15px;">Ratio</b>: <strong style="font-size: 25px">' + helper.props.additionalData + '</strong>');
                            } else {
                                finalSTR += ('<b style="font-size: 15px;">' + this.series.name + '</b>: <strong style="font-size: 25px">' + (Number.isInteger(this.y) ? this.y : this.y.toFixed(3)) + ' ' + helper.props.unit + '</strong>');
                            }
                            finalSTR += "<br/>";
                        });
                        return finalSTR;
                    },
                    shared: true,
                }
            },
            hoverData: null
        };

        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgba(0,0,0,0)'],
                        [1, 'rgba(0,0,0,0)']
                    ]
                },
                marginLeft: 50,
            },
            title: {
                style: {
                    color: '#ffffff',
                    font: 'bold 16px "Trebuchet MS", Verdana, sans-serif'
                }
            },
            legend: {
                itemStyle: {
                    font: '13pt Iceland',
                    color: '#ffffff'
                },
                itemHoverStyle: {
                    color: 'gray'
                }
            },
            yAxis: {
                labels: {
                    align: 'right',
                    x: -10,
                    y: -1,
                    style: {
                        color: "#FFFFFF",
                        font: '14px Iceland',
                    }
                }
            },
            xAxis: {
                visible: false,
                labels: {
                    enabled: false
                }
            },
        });

        Highcharts.Tooltip.prototype.hide = function () {
            // Empty to avoid tooltips from hiding
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            (prevProps.maxYAxis !== this.props.maxYAxis || prevProps.minYAxis !== this.props.minYAxis) ||
            (prevProps.data !== this.props.data)
        ) {
            let data = null;
            if (this.props.data2) {
                data = [
                    {
                        name: this.props.dataName,
                        data: this.props.data,
                        visible: this.props.hoverTriggerIndex[0],
                        color: (this.props.color ? this.props.color : '#ff0012'),
                    },
                    {
                        name: this.props.data2Name,
                        data: this.props.data2,
                        visible: this.props.hoverTriggerIndex[1],
                        color: '#50B432',
                    },
                ];
            } else {
                data = [
                    {
                        name: this.props.dataName,
                        data: this.props.data,
                        color: (this.props.color ? this.props.color : '#ff0012')
                    },
                ];
            }

            this.setState({
                chartOptions: {
                    series: data,
                    yAxis: {
                        title: "",
                        max: this.props.maxYAxis,
                        min: this.props.minYAxis,
                        tickInterval: this.props.tick,
                    },
                }
            });
        }
    }

    setHoverData(e) {
        try {
            this.setState({
                hoverData: e.target.category,
                index: e.target.index,
            });

            this.props.updateShow(e.target.index);

            for (let i = 0; i < Highcharts.charts.length; i++) {
                if (Highcharts.charts[i] && (e.target.index < Highcharts.charts[i].series[0].points.length)) {
                    let temp = [];
                    for (let j = 0; j < Highcharts.charts[i].series.length; j++) {
                        if (Highcharts.charts[i].series[j].visible) {
                            temp.push(Highcharts.charts[i].series[j].data[e.target.index]);
                        }
                    }
                    Highcharts.charts[i].tooltip.refresh(temp);
                }
            }
        } catch (e) {
            console.error("MINOR ERROR: charts tooltips, nothing serious...", e);
        }
    }

    render() {
        // eslint-disable-next-line
        const {chartOptions, hoverData} = this.state;

        return (
            <>
                {(this.props.maxYAxis > 0) ? (
                    <div id={"graphContainer"}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={chartOptions}
                        />
                    </div>
                ) : null}
            </>
        );
    }
}

export default LineChart;